import { computed, defineComponent, onMounted } from 'vue';

export default defineComponent({
  name: 'dl-doormat-module',
  props: {
    tagName: { type: String, default: 'a' },
    dynamicProperties: { type: Object, default: () => ({}) },
    title: { type: String, default: '' },
    modAlt: Boolean
  },
  setup(props) {
    const classes = computed(() => [
      'vl-doormat',
      {
        'vl-doormat--alt': props.modAlt
      }
    ]);

    return { classes };
  }
});
